import React from 'react';
import { CUES_HELP_COPY } from './sources';
import HelpSection from './Help/HelpSection';

const CuesToolbarCTA = () => {
  const { text, ctaText, href, trackingEvent } = CUES_HELP_COPY;

  return (
    <HelpSection
      text={text}
      ctaText={ctaText}
      href={href}
      trackingEvent={trackingEvent}
      variant="fullWidth"
    />
  );
};

export default CuesToolbarCTA;
